import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, Facebook, Twitter, Linkedin, Instagram, ArrowRight } from "lucide-react";
import { COMPANY, SERVICES } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-[#061a3a] text-slate-200 pt-16 pb-6 mt-4">
      <div className="container-x grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="bg-white/95 rounded-xl p-2 shadow-lg inline-flex">
              <img src="/brand/logo.png" alt="Fortunexis Finance" className="h-14 w-auto object-contain" />
            </div>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">
            Specialised financial consultants providing trade finance, project funding and corporate finance services from Dubai to global markets.
          </p>
          <div className="flex items-center gap-2 mt-5">
            {[Facebook, Twitter, Linkedin, Instagram].map((Icon, i) => (
              <a key={i} href="#" className="w-8 h-8 rounded-full bg-white/5 hover:bg-[#1e40af] flex items-center justify-center transition-colors">
                <Icon size={14} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm tracking-widest uppercase">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            {["Home", "About Us", "Blog", "Contact Us"].map((l) => (
              <li key={l}>
                <Link to={l === "Home" ? "/" : `/${l.toLowerCase().replace(/\s/g, "")}`} className="hover:text-amber-300 transition-colors flex items-center gap-2">
                  <ArrowRight size={12} /> {l}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm tracking-widest uppercase">Our Services</h4>
          <ul className="space-y-2 text-sm">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}`} className="hover:text-amber-300 transition-colors flex items-center gap-2">
                  <ArrowRight size={12} /> {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm tracking-widest uppercase">Get In Touch</h4>
          <ul className="space-y-3 text-sm text-slate-300">
            <li className="flex items-start gap-3"><MapPin size={16} className="text-[#2563eb] mt-0.5" /> {COMPANY.address}</li>
            <li className="flex items-center gap-3"><Mail size={16} className="text-[#2563eb]" /> {COMPANY.email}</li>
            {COMPANY.phones.map((p) => (
              <li key={p.number} className="flex items-center gap-3"><Phone size={16} className="text-[#2563eb]" /> {p.number}</li>
            ))}
          </ul>
        </div>
      </div>

      <div className="container-x mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between items-center text-xs text-slate-400">
        <div>© {new Date().getFullYear()} Fortunexis LLC. All rights reserved.</div>
        <div className="flex gap-5 mt-2 md:mt-0">
          <a href="#" className="hover:text-white">Privacy Policy</a>
          <a href="#" className="hover:text-white">Terms of Service</a>
          <a href="#" className="hover:text-white">Sitemap</a>
        </div>
      </div>
    </footer>
  );
}
